import { PartNumber } from '@models/partNumber.model';
import { Line } from '@models/line.model';
import { User } from '@models/user.model';
import { Tool } from '@app/tool/model/tool.model';
import { GroupChildWrapper } from '@app/tool/model/group-child-wrapper.model';
import { Group } from '@app/tool/model/group.model';
import { Facility } from '@models/facility.model';
import { InsertionCycle } from '@models/insertion-cycle.model';
import {ToolRequestType} from "@models/enums/tool-request-type.enum";

export class ToolRequest {
    public id: number;
    public name: string;
    public partNumber: PartNumber;
    public line: Line;
    public createdBy: User;
    public assignedTo: User;
    public createdDate: string;
    public closedDate: string;
    public requestTools: Tool[];
    public status: string;
    public highPriority: boolean;
    public facility: Facility;
    public priorityReason: string;
    public closeReason: string;
    public isApprovable: boolean;
    public toolRequestsToBeClosed: any[];
    public toolRequestToBeApproved: any;
    public isForAnIssue: boolean;
    public insertionCycle: InsertionCycle;
    public isForNonReturnableTools: boolean;
    public type: ToolRequestType;
    public mainToolLines: string;

    constructor(toolRequest: any = {}) {
        this.id = toolRequest.id || 0;
        this.name = toolRequest.name || '';

        if (toolRequest.partNumber) {
            this.partNumber = this.mapPartNumber(toolRequest.partNumber);
        }

        this.line = this.mapLine(toolRequest.line);

        if (toolRequest.createdBy) {
            this.createdBy = new User(toolRequest.createdBy);
        }

        if (toolRequest.assignedTo) {
            this.assignedTo = new User(toolRequest.assignedTo);
        }

        if (toolRequest.facility) {
            this.facility = new Facility(toolRequest.facility);
        }

        this.createdDate = toolRequest.createdDate || '';
        this.closedDate = toolRequest.closedDate || '';
        this.status = toolRequest.status || '';
        this.requestTools = this.mapGroupableItems(toolRequest.requestTools);
        this.highPriority = toolRequest.highPriority || false;
        this.priorityReason = toolRequest.priorityReason;
        this.closeReason = toolRequest.closeReason;
        this.isApprovable = toolRequest.isApprovable;
        this.toolRequestsToBeClosed = toolRequest.toolRequestsToBeClosed ? toolRequest.toolRequestsToBeClosed : [];
        this.toolRequestToBeApproved = toolRequest.toolRequestToBeApproved ? toolRequest.toolRequestToBeApproved : '';
        this.isForAnIssue = toolRequest.isForAnIssue || false;
        this.insertionCycle = toolRequest.insertionCycle || '';
        this.isForNonReturnableTools = toolRequest.isForNonReturnableTools;
        this.type = toolRequest.type ?  toolRequest.type : 0;
        this.mainToolLines = toolRequest.mainToolLines || '';
    }

    mapPartNumber(partNumber) {
        return new PartNumber(partNumber);
    }

    mapLine(line) {
        return new Line(line);
    }

    mapGroupableItems(items) {
        if (items) {
            const groups = items.items.map((group) => {
                if (group.subGroup) {
                    return new Group(group);
                }
                return new GroupChildWrapper(group).item;
            });
            return groups;
        }
        return [];
    }
}
